import React from 'react';
import { MailIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { FaqList } from '../components/FaqList';
import { faqs } from '../data/faq';
import { SUPPORT_EMAIL } from '../lib/links';
export function Support() {
  return <>
      <PageHeader title="Support" intro="Email us and a person replies. Many answers are below already." data-id="element-453" data-mp="znrwf0bamj2i" />

      <section aria-labelledby="contact" className="bg-cream" data-id="element-454" data-mp="2xscyatlu055">
        <div className="mx-auto max-w-content px-5 py-16 sm:px-6 md:py-20" data-id="element-455" data-mp="2zd5xw09tb0w">
          <h2 id="contact" className="font-display text-[32px] tracking-tight text-ink md:text-[40px]" data-id="element-456" data-mp="7xepsj5itedf">
            Get in touch
          </h2>
          <p className="mt-4 max-w-xl text-[18px] text-ink-soft" data-id="element-457" data-mp="c0josbqe6xxb">
            Billing, an adventure that will not load, a request for a world we have not made yet: all of it goes
            to the same inbox.
          </p>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="mt-7 inline-flex max-w-full items-center gap-3 rounded-2xl border-2 border-ink bg-white px-5 py-4 font-display text-[17px] text-ink shadow-chunky-sm transition-colors duration-150 ease-out hover:bg-lavender-soft sm:text-[19px]" data-id="element-458" data-mp="1sbxh5n2ck82c">
            <MailIcon className="h-5 w-5 shrink-0 text-coral-dark" aria-hidden="true" data-id="element-459" data-mp="1rxwmj4n3nt3h" />
            <span className="break-all" data-id="element-460" data-mp="1n0mk8oem3my8">{SUPPORT_EMAIL}</span>
          </a>
        </div>
      </section>

      <section aria-labelledby="support-faq" className="bg-lavender-soft" data-id="element-461" data-mp="1izb5jdxa0m4t">
        <div className="mx-auto max-w-4xl px-5 py-16 sm:px-6 md:py-20" data-id="element-462" data-mp="1e7t30lfludhq">
          <h2 id="support-faq" className="font-display text-[32px] tracking-tight text-ink md:text-[40px]" data-id="element-463" data-mp="1e5oprcvtg24s">
            Common questions
          </h2>
          <div className="mt-10" data-id="element-464" data-mp="14aem6kprrmow">
            <FaqList items={faqs} data-id="element-465" data-mp="1478xv7oysou8" />
          </div>
        </div>
      </section>
    </>;
}